import React, { Component } from "react";
import { connect } from "react-redux";

import * as authDrawerConstants from "../../../constants/authDrawer";
import { toggleAuthDrawer, changeStep } from "../../../actions/authDrawer";
import Icon from "../../../components/Library/Icon/Icon";

import styles from "./SubscribeComplete.css";

class SubscribeComplete extends Component {
  onSignUpNow = () => {
    this.props.toggleAuthDrawer(true);
    this.props.changeStep(authDrawerConstants.REGISTER1);
  };

  render() {
    const { subscription } = this.props;
    if (!subscription) return null;

    return (
      <div className={styles.root}>
        <Icon className={styles.checkmark} name="check/rounded" />
        <div className={styles.text}>
          <div>
            Thanks for subscribing to <strong>{subscription.name}</strong>!
          </div>
          <hr className={styles.separator} aria-hidden={true}/>
          <div>
            Sign up for an account to save stories and manage your subscriptions.
          </div>
        </div>
        <button className={styles.signUp} onClick={this.onSignUpNow} alt="Sign up now">
          Sign up now
        </button>
      </div>
    );
  }
}

export default connect(null, { toggleAuthDrawer, changeStep })(SubscribeComplete);



// WEBPACK FOOTER //
// ./src/author/components/SubscribeComplete/SubscribeComplete.js